/**
 * Field label mapping for Benefit Verification form fields
 * Maps form field names to their display labels for change tracking
 */
export const fieldLabelMap: Record<string, string> = {
	clinic: 'Clinic',
	provider: 'Physician',
	patient: 'Patient',
	patientFirstName: 'First Name',
	patientLastName: 'Last Name',
	birthdate: 'Birth Date',
	primaryInsurance: 'Primary Insurance',
	ta_primarymemberid: 'Primary Member ID',
	secondaryInsurance: 'Secondary Insurance',
	ta_secondarymemberid: 'Secondary Member ID',
	ta_emrid: 'EMR ID',
	mobilephone: 'Mobile Phone',
	emailaddress1: 'Email',
	ta_nursinghome: 'Nursing Home',
	ta_100days: '100 Days',
	ta_productselection: 'Product(s)',
	ta_noteshartreview: 'Notes',
	ta_proceduredate: 'Procedure Date',
	ta_woundlength: 'Wound Length',
	ta_woundwidth: 'Wound Width',
	ta_wounddepth: 'Wound Depth',
	ta_woundsizetotal2: 'Wound Size Total',
	ta_woundtype1: 'Wound Type 1',
	'ta_ApplicationCode1@odatabind': 'Application Code 1',
	'ta_ApplicationCode2@odatabind': 'Application Code 2',
	'ta_DiagnosisCode1@odatabind': 'Primary Diagnosis',
	'ta_DiagnosisCode2@odatabind': 'Diagnosis Code 2',
	'ta_DiagnosisCode3@odatabind': 'Diagnosis Code 3',
	'ta_DiagnosisCode4@odatabind': 'Diagnosis Code 4',
	ta_wound2_woundlength: 'Wound 2 Length',
	ta_wound2_woundwidth: 'Wound 2 Width',
	ta_wound2_wounddepth: 'Wound 2 Depth',
	ta_wound2_woundsizetotal: 'Wound 2 Size Total',
	ta_woundtype2: 'Wound Type 2',
	'ta_Wound2_Application1@odatabind': 'Wound 2 Application 1',
	'ta_Wound2_Application2@odatabind': 'Wound 2 Application 2',
	'ta_Wound2_Diagnosis1@odatabind': 'Wound 2 Diagnosis 1',
	'ta_Wound2_Diagnosis2@odatabind': 'Wound 2 Diagnosis 2',
	'ta_Wound2_Diagnosis3@odatabind': 'Wound 2 Diagnosis 3',
	'ta_Wound2_Diagnosis4@odatabind': 'Wound 2 Diagnosis 4',
	ta_wound3_woundlength: 'Wound 3 Length',
	ta_wound3_woundwidth: 'Wound 3 Width',
	ta_wound3_wounddepth: 'Wound 3 Depth',
	ta_wound3_woundsizetotal: 'Wound 3 Size Total',
	ta_woundtype3: 'Wound Type 3',
	'ta_Wound3_Application1@odatabind': 'Wound 3 Application 1',
	'ta_Wound3_Application2@odatabind': 'Wound 3 Application 2',
	'ta_Wound3_Diagnosis1@odatabind': 'Wound 3 Diagnosis 1',
	'ta_Wound3_Diagnosis2@odatabind': 'Wound 3 Diagnosis 2',
	'ta_Wound3_Diagnosis3@odatabind': 'Wound 3 Diagnosis 3',
	'ta_Wound3_Diagnosis4@odatabind': 'Wound 3 Diagnosis 4',
	ta_portalbvupload: 'Uploads',
};

